import InlineTooltip from '../../common/InlineTooltip';
import { renderRow } from './SearchResultsRow';
import PropTypes from 'prop-types';

const SearchPeerResults = ({ history, peer, queryParams, breadCrumbs }) => {
  const { prefix, returnUrl } = queryParams;

  const selectPeer = () => {
    const today = new Date().toISOString().split('T')[0]; // yyyy-mm-dd

    let params =
      '?' +
      prefix +
      '_person_id=' +
      peer['Person ID'] +
      '&' +
      prefix +
      '_peer_name=' +
      peer.FullName +
      '&' +
      prefix +
      '_relationship_start_date=' +
      today;

    for (const [key, value] of Object.entries(queryParams)) {
      if (key !== 'returnUrl' && key !== 'prefix') {
        params += '&' + key + '=' + value;
      }
    }

    history.push({
      pathname: returnUrl,
      search: params,
      state: { breadCrumbs: breadCrumbs },
    });
  };

  return (
    <div style={{ padding: '15px 0' }}>
      <h3 onClick={selectPeer} style={{ cursor: 'pointer' }}>
        {peer.FirstName} {peer.Surname}
      </h3>
      <table className="practitioner-result">
        <tbody>
          <tr>
            <th>Person ID:</th>
            <td>{peer['Person ID']}</td>
          </tr>
        </tbody>
      </table>
      {peer.Practices.map((practice, index) => (
        // Odoo practice rows have no guaranteed unique id; index is acceptable for this static list
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <table className="practitioner-result" key={index}>
          <tbody>
            {practice.Practice && (
              <tr>
                <th colSpan="2">
                  <h4>{practice.Practice}</h4>
                </th>
              </tr>
            )}
            {renderRow(
              <th>
                <InlineTooltip>Qualification(s):</InlineTooltip>
              </th>,
              practice.Qualifications,
            )}
            {renderRow('Scope of Practice Registration date:', practice.RegistrationDate)}
            {renderRow('Health Provider Index number:', practice.HPINumber)}
            {renderRow('Registration Status:', practice.Status)}
            {renderRow('Practising Status:', practice.APCStatus)}
            {renderRow('Annual Practising Certificate Period:', practice.APCPeriod)}
          </tbody>
        </table>
      ))}
    </div>
  );
};

SearchPeerResults.propTypes = {
  history: PropTypes.object,
  peer: PropTypes.object,
  queryParams: PropTypes.object,
  breadCrumbs: PropTypes.array,
};

export default SearchPeerResults;
